import { Box, Typography } from "@mui/material";
import { Trans, useTranslation } from "react-i18next";
import implementImg from "../assets/implement.png";

export default function CasesClosing() {
  useTranslation();

  return (
    <Box
      component="section"
      sx={{
        bgcolor: "#CEFF1A",
        minHeight: { md: 570.47, xs: 520 },
        display: "flex",
        alignItems: "center",
      }}
    >
      <Box sx={{ maxWidth: 1440, mx: "auto", width: "100%", px: { xs: 2, md: 3 } }}>
        <Box
          sx={{
            maxWidth: 1248,
            mx: "auto",
            width: "100%",
            py: { xs: 6, md: 8 },
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            gap: { xs: 3, md: 4 },
          }}
        >
          <Box
            component="img"
            src={implementImg}
            alt=""
            role="presentation"
            sx={{
              width: { xs: 420, sm: 520, md: 650 },
              height: "auto",
              userSelect: "none",
              pointerEvents: "none",
              mt: -10,
              mb: 1.5,
            }}
          />

          <Box sx={{ maxWidth: { xs: 720, md: 1000 }, textAlign: "center" }}>
            <Typography
              component="h3"
              sx={{
                color: "#0b0c0b",
                fontFamily: "Poppins",
                fontWeight: 800,
                lineHeight: 1.15,
                fontSize: { xs: 28, md: 44 },
                letterSpacing: 0.5,
                mb: { xs: 1, md: 1.5 },
              }}
            >
              <Trans
                i18nKey="closing.title"
                components={{ bold: <Box key="bold" component="span" sx={{ fontWeight: 800 }} /> }}
                defaults="<bold>Configurar é só o começo.</bold>"
              />
            </Typography>

            <Typography
              sx={{
                color: "#0b0c0b",
                fontFamily: "Poppins",
                fontWeight: 400,
                lineHeight: 1.6,
                fontSize: { xs: 20, md: 26 },
                letterSpacing: 0.5,
              }}
            >
              <Trans
                i18nKey="closing.body"
                components={{
                  bold: <Box key="bold" component="span" sx={{ fontWeight: 800 }} />,
                  br1: <br key="br1" />,
                  br2: <br key="br2" />,
                }}
                defaults="<bold>Implementar uma IA generativa não é um projeto pontual</bold>.<br/> É um <bold>produto vivo</bold> que precisa <bold>evoluir constantemente</bold> com o mercado, a marca e o comportamento dos clientes."
              />
            </Typography>
          </Box>
        </Box>
      </Box>
    </Box>
  );
}